import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Recipe } from 'state/recipe/model';
import { Container, Row, Col } from 'reactstrap';

interface State { }

interface Props extends RouteComponentProps<any> {
  recipe: Recipe,
  fetchRecipe(id: string): Promise<Recipe>
}

export default class ShowRecipe extends React.Component<Props, State> {
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchRecipe(id);
  }


  render() {
    const { recipe } = this.props;
    if (!recipe) { return <div>Loading...</div> }
    return (
      <Container>
        <Row>
          <h2>{recipe.name}</h2>
        </Row>
        <Row>
          <h5>Ingredients</h5>
        </Row>
        <Row>
          <ol>
            {recipe.ingredients && recipe.ingredients.map(ingredient => {
              return <li key={ingredient.id}><p>{`${ingredient.quantity} ${ingredient.unit || ''} ${ingredient.name}`}</p></li>
            })}
          </ol>
        </Row>
        <Row>
          <h5>Instructions</h5>
        </Row>
        <Row>
          <p>{recipe.instructions}</p>
        </Row>
      </Container>
    )
  }
}